import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { array, func } from 'prop-types';

import { isMobile } from '@snapask/common-components/dist/utils/detectMobileType';
import { ACADEMY_PAGE_TEMPLATE } from '@snapask/common-components/dist/constants/routingPath';

import Link from '@blueberry/components/Link';

import { generateAcademyURL } from '@blueberry/redux/navigation';

import styles from './PageList.scss';

function chunkArray(array, chunkSize) {
  const clonedArray = [...array];
  const results = [];
  while (clonedArray.length) {
    results.push(clonedArray.splice(0, chunkSize));
  }
  return results;
}

function PageList({ pages, getAcademyURL, checkIsScrollable }) {
  const [hoverListPosition, setHoverListPosition] = useState({ x: 0, y: 0 });
  const renderDropdownMenuItem = item => {
    const { title, id } = item;
    return (
      <li key={id} className={styles.dropdownMenuItem}>
        <Link
          to={getAcademyURL('/channel/:id', { id })}
          className={styles.link}
        >
          {title}
        </Link>
      </li>
    );
  };

  useEffect(() => {
    checkIsScrollable();
  }, [pages, checkIsScrollable]);

  const onMouseOver = e => {
    e.stopPropagation();

    const dropdownTrigger = e.target.closest('[role=dropdownTrigger]');
    const elementPosition = dropdownTrigger.getBoundingClientRect();

    setHoverListPosition({
      x: elementPosition.left,
      y: elementPosition.bottom,
    });
  };

  const renderPage = page => {
    const { display_name, name, nameWithoutRegion, channels } = page;
    const { x, y } = hoverListPosition;
    const hasDropdown =
      !isMobile() && Array.isArray(channels) && channels.length > 0;
    const dropdownMenuList = chunkArray(channels, 5);

    return (
      <React.Fragment key={name}>
        <li
          role="dropdownTrigger"
          onMouseOver={onMouseOver}
          className={styles.trigger}
        >
          <Link
            to={getAcademyURL(ACADEMY_PAGE_TEMPLATE, {
              name: nameWithoutRegion,
            })}
            className={styles.title}
          >
            {display_name}
          </Link>
          {hasDropdown && (
            <div className={styles.dropdown} style={{ left: x, top: y }}>
              <ul className={styles.dropdownMenu}>
                {dropdownMenuList.map((dropdownMenuGroup, index) => (
                  <li key={index} className={styles.dropdownMenuGroup}>
                    <ul>{dropdownMenuGroup.map(renderDropdownMenuItem)}</ul>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </li>
      </React.Fragment>
    );
  };
  return <ul className={styles.root}>{pages.map(renderPage)}</ul>;
}

PageList.propTypes = {
  checkIsScrollable: func.isRequired,
  getAcademyURL: func.isRequired,
  pages: array.isRequired,
};

export default connect(state => ({ getAcademyURL: generateAcademyURL(state) }))(
  PageList
);



// WEBPACK FOOTER //
// ./app/components/PageListHeader/components/PageList/PageList.jsx